import { TIRE_QUOTE_SEARCH_URL } from 'constants/ApiConstants';

import type { MetaAction } from 'modules/global/generic.types';
import type {
  CloseTireQuoteImportModalAction, FetchTireQuoteParams,
  GetTireQuoteAction,
  OpenTireQuoteImportModalAction
} from 'modules/tireQuote/types';
import { cleanPayload } from 'utils/RequestUtils';

import * as types from '../actionTypes';

export const getTireQuotes = (params: FetchTireQuoteParams, meta: MetaAction = {}): GetTireQuoteAction => ({
  type: types.SEARCH_TIRE_QUOTES_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: TIRE_QUOTE_SEARCH_URL,
      params: cleanPayload(params),
    },
  },
  meta: {
    '@app-request': true,
    ...meta
  },
});

export const openImportTireQuotes = (meta: MetaAction = {}): OpenTireQuoteImportModalAction => ({
  type: types.OPEN_TIRE_QUOTES_IMPORT_MODAL,
  meta
});

export const closeImportTireQuotes = (meta: MetaAction = {}): CloseTireQuoteImportModalAction => ({
  type: types.CLOSE_TIRE_QUOTES_IMPORT_MODAL,
  meta
});
